import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export interface BulkActionsTheme {
  container: {
    background: string;
    borderColor: string;
    shadow: string;
  };
  outerBorder: {
    borderColor: string;
  };
  badge: {
    background: string;
    color: string;
  };
  title: {
    color: string;
  };
  subtitle: {
    color: string;
  };
  closeIcon: {
    color: string;
  };
  buttonGroup: {
    background: string;
    shadow: string;
  };
  actionButton: {
    color: string;
    hover: {
      background: string;
    };
  };
}

const bulkActionsTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      container: {
        background: `linear-gradient(0deg, ${theme.color.focus[5]} 0%, ${theme.color.focus[6]} 100%)`,
        borderColor: theme.color.focus[5],
        shadow:
          key === 'light'
            ? '0px 4px 36px 0px rgba(17, 147, 173, 0.5)'
            : '0px 4px 36px 0px rgba(0, 0, 0, 0.6)',
      },
      outerBorder: {
        borderColor: theme.color.focus[1],
      },
      badge: {
        background: theme.color.focus[3],
        color: theme.color.text.core[key === 'light' ? 'on-dark-primary' : 'on-light-primary'],
      },
      title: {
        color: theme.color.text.core['-primary'],
      },
      subtitle: {
        color: theme.color.text.core['-primary'],
      },
      closeIcon: {
        color: theme.color.text.core['-primary'],
      },
      buttonGroup: {
        background: `linear-gradient(0deg, ${theme.color.focus[5]} -10.34%, ${theme.color.focus[6]} 100%)`,
        shadow:
          key === 'light'
            ? '0px 4px 4px 0px rgba(0, 0, 0, 0.1), 0px -4px 4px 0px rgba(255, 255, 255, 0.1), inset 0px -2px 2px 0px rgba(0, 0, 0, 0.1), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.1)'
            : '0px 4px 4px 0px rgba(0, 0, 0, 0.3), 0px -4px 4px 0px rgba(255, 255, 255, 0.05), inset 0px -2px 2px 0px rgba(0, 0, 0, 0.3), inset 0px 1px 1px 0px rgba(255, 255, 255, 0.05)',
      },
      actionButton: {
        color: theme.color.focus[1],
        hover: {
          background: key === 'light' ? 'rgba(21, 91, 104, 0.1)' : 'rgba(193, 239, 249, 0.1)',
        },
      },
    },
  ]),
);

export default bulkActionsTheme;
